import { Col, Container, Row } from "react-bootstrap";
import { FaFacebook, FaGithub, FaLinkedin, FaXing } from "react-icons/fa";
import logo from "../assets/Logo/logo.png";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          {/* <MailchimpForm /> */}
          <Col size={12} sm={6}>
            <img src={logo} alt="Logo" />
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a href="https://github.com/HasanMdKamrul">
                <span>
                  <FaGithub className="text-white " />
                </span>
              </a>
              <a href="https://www.linkedin.com/in/md-kamrul-hasan-590809171/">
                <span>
                  <FaLinkedin className="text-white " />
                </span>
              </a>
              <a href="https://www.xing.com/profile/MDKAMRUL_HASAN13/cv">
                <span>
                  <FaXing className="text-white " />
                </span>
              </a>
              <a href="https://www.facebook.com/kamrulhasan.tanmoy.79/">
                <span>
                  <FaFacebook className="text-white " />
                </span>
              </a>
            </div>
            <p>Md Kamrul Hasan | Copyright 2022. All Rights Reserved</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
